<main class="content-area">
    <h1>Bacnet Connectors</h1>

    <div class="limit-height" style="max-width:1200px;">
        <clr-datagrid class="datagrid-compact" [(clrDgSingleSelected)]="selectedConnector" [clrDgRowSelection]="true" [clrDgLoading]="loadingConnectors">

            <clr-dg-column [clrDgField]="'Driver.enabled'"> Enabled </clr-dg-column>
            <clr-dg-column [clrDgField]="'Driver.name'" [clrDgSortOrder]="ascSort"> Name </clr-dg-column>
            <clr-dg-column [clrDgField]="'Driver.description'"> Description </clr-dg-column>
            <clr-dg-column [clrDgField]="'Driver.defaultxautogroup'"> Default XAutoGroup </clr-dg-column>
            <clr-dg-column [clrDgField]="'Driver.defaultxgroup'"> Default XGroup </clr-dg-column>

            <clr-dg-row *clrDgItems="let connector of connectors" [clrDgItem]="connector">
                <clr-dg-cell class="cellhideoverflow"> {{connector.Driver.enabled}} </clr-dg-cell>
                <clr-dg-cell class="cellhideoverflow"> {{connector.Driver.name}} </clr-dg-cell>
                <clr-dg-cell class="cellhideoverflow"> {{connector.Driver.description}} </clr-dg-cell>
                <clr-dg-cell class="cellhideoverflow"> {{connector.Driver.defaultxautogroup}} </clr-dg-cell>
                <clr-dg-cell class="cellhideoverflow"> {{connector.Driver.defaultxgroup}} </clr-dg-cell>
            </clr-dg-row>

            <clr-dg-footer>
                <clr-dg-pagination #pagination [clrDgPageSize]="sizeOptions[0]">
                    <clr-dg-page-size [clrPageSizeOptions]="sizeOptions">Connectors per page</clr-dg-page-size>
                    {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}} of {{pagination.totalItems}} Bacnet Connectors
                </clr-dg-pagination>
            </clr-dg-footer>
        </clr-datagrid>
    </div>

    <button class="btn btn-link " (click)="addConnector()">
        <clr-icon shape="plus-circle "></clr-icon>
        New Bacnet connector
    </button>
    <button *ngIf="selectedConnector" type="button" class="btn btn-link" [clrLoading]="savingRemovingDriver" (click)="removeDriver(); ">
        <clr-icon shape="minus-circle "></clr-icon>
        Remove connector
    </button>


    <clr-accordion [clrAccordionMultiPanel]="true" *ngIf="selectedConnector">

        <clr-accordion-panel [clrAccordionPanelOpen]="true">
            <clr-accordion-title>Connector configuration</clr-accordion-title>
            <clr-accordion-content>

                <form clrForm>
                    <clr-input-container>
                        <label>Driver ID </label>
                        <input clrInput type="text" [(ngModel)]="selectedConnector.Driver.xautodriverid" name="xautodriverid" disabled size="35" />
                    </clr-input-container>

                    <clr-input-container>
                        <label>Name </label>
                        <input clrInput type="text" [(ngModel)]="selectedConnector.Driver.name" name="drivername" size="35" />
                    </clr-input-container>

                    <clr-input-container>
                        <label>Description </label>
                        <input clrInput type="text" [(ngModel)]="selectedConnector.Driver.description" name="driverdescription" size="35" />
                    </clr-input-container>

                    <clr-input-container>
                        <label>Default XAuto Group </label>
                        <input clrInput type="text" [(ngModel)]="selectedConnector.Driver.defaultxautogroup" name="driverdefaultxautogroup" size="35" />
                    </clr-input-container>

                    <clr-input-container>
                        <label>Default XGroup </label>
                        <input clrInput type="text" [(ngModel)]="selectedConnector.Driver.defaultxgroup" name="driverdefaultxgroup" size="35" />
                    </clr-input-container>

                    <clr-input-container>
                        <label>Device Instance</label>
                        <input clrInput type="number" [(ngModel)]="selectedConnector.Bacnet.deviceinstance" name="driverdeviceinstanceid" size="35" />
                    </clr-input-container>


                    <clr-input-container>
                        <label>Device Object Name</label>
                        <input clrInput type="text" [(ngModel)]="selectedConnector.Bacnet.objectname" name="driverobjectname" size="35" />
                    </clr-input-container>
                    
                    <clr-toggle-container>
                        <clr-toggle-wrapper>
                            <input type="checkbox" clrToggle value="true" name="enableautodiscover" [(ngModel)]="selectedConnector.Bacnet.enableautodiscover" />
                            <label>Auto discover</label>
                        </clr-toggle-wrapper>
                    </clr-toggle-container>
                    <clr-toggle-container>
                        <clr-toggle-wrapper>
                            <input type="checkbox" clrToggle value="true" name="enableautoprovisioning" [(ngModel)]="selectedConnector.Bacnet.enableautoprovisioning" />
                            <label>Auto provisioning</label>
                        </clr-toggle-wrapper>
                    </clr-toggle-container>

                    <clr-toggle-container>
                        <clr-toggle-wrapper>
                            <input type="checkbox" clrToggle value="true" name="driverenabled" [(ngModel)]="selectedConnector.Driver.enabled" />
                            <label>Enabled</label>
                        </clr-toggle-wrapper>
                    </clr-toggle-container>

                    <clr-accordion [clrAccordionMultiPanel]="true" *ngIf="selectedConnector">

                        <clr-accordion-panel [clrAccordionPanelOpen]="true">
                            <clr-accordion-title>Manually probe IP</clr-accordion-title>
                            <clr-accordion-content>
                            
                            <p>Manually add IP-addresses to probe for discovery. Added IP-addresses are automatically removed once probed, the signals can be viewed under Discovered.</p>
                            <div class="limit-height" style="max-width:1200px;">
                                <clr-datagrid class="datagrid-compact" [clrDgLoading]="loadingConnectors">
            
                                    <clr-dg-column [clrDgField]="'ip'"> IP </clr-dg-column>
            
                                    <clr-dg-row *clrDgItems="let disc of selectedConnector.Bacnet.manuallyprobeipaddresses" [clrDgItem]="disc">
                                        <clr-dg-cell class="cellhideoverflow"> {{disc}} </clr-dg-cell>
            
                                    </clr-dg-row>
            
                                    <clr-dg-footer>
                                        <clr-dg-pagination #paginationdisc [clrDgPageSize]="sizeOptions[1]">
                                            <clr-dg-page-size [clrPageSizeOptions]="sizeOptions">IPs per page</clr-dg-page-size>
                                            {{paginationdisc.firstItem + 1}} - {{paginationdisc.lastItem + 1}} of {{paginationdisc.totalItems}} IPs
                                        </clr-dg-pagination>
                                    </clr-dg-footer>
                                </clr-datagrid>
                            </div>

                            <clr-input-container>
                                <label>IP</label>
                                <input clrInput type="text" [(ngModel)]="addprobeip" name="addprobeip" size="35" />                                
                            </clr-input-container>
                            <button class="btn" [clrLoading]="savingDriver" (click)="addManuallyProbeIP()">Add</button>
                            </clr-accordion-content>
                        </clr-accordion-panel>
                    </clr-accordion>

                    <button class="btn" [clrLoading]="savingDriver" (click)="saveDriver()">Save</button>

                </form>
            </clr-accordion-content>
        </clr-accordion-panel>

        <clr-accordion-panel [clrAccordionPanelOpen]="false">
            <clr-accordion-title>Connector Variables</clr-accordion-title>
            <clr-accordion-content>
                <div class="limit-height" style="max-width:1200px;">
                    <clr-datagrid class="datagrid-compact" [(clrDgSingleSelected)]="selectedVariable" [clrDgRowSelection]="true" [clrDgLoading]="loadingConnectors">

                        <clr-dg-column [clrDgField]="'enabled'"> Enabled </clr-dg-column>
                        <clr-dg-column [clrDgField]="'name'" [clrDgSortOrder]="ascSort"> Name </clr-dg-column>
                        <clr-dg-column [clrDgField]="'description'"> Description </clr-dg-column>
                        <clr-dg-column [clrDgField]="'xautogroup'"> XAutoGroup </clr-dg-column>
                        <clr-dg-column [clrDgField]="'xgroup'"> XGroup </clr-dg-column>
                        <clr-dg-column [clrDgField]="'defaultscriptname'"> Default scriptname </clr-dg-column>

                        <clr-dg-row *clrDgItems="let variable of selectedConnector.Variables" [clrDgItem]="variable">
                            <clr-dg-cell class="cellhideoverflow"> {{variable.Variable.enabled}} </clr-dg-cell>
                            <clr-dg-cell class="cellhideoverflow"> {{variable.Variable.name}} </clr-dg-cell>
                            <clr-dg-cell class="cellhideoverflow"> {{variable.Variable.description}} </clr-dg-cell>
                            <clr-dg-cell class="cellhideoverflow"> {{variable.Variable.xautogroup}} </clr-dg-cell>
                            <clr-dg-cell class="cellhideoverflow"> {{variable.Variable.xgroup}} </clr-dg-cell>
                            <clr-dg-cell class="cellhideoverflow"> {{variable.Variable.defaultscriptname}} </clr-dg-cell>
                        </clr-dg-row>

                        <clr-dg-footer>
                            <clr-dg-pagination #pagination [clrDgPageSize]="sizeOptions[1]">
                                <clr-dg-page-size [clrPageSizeOptions]="sizeOptions">Variables per page</clr-dg-page-size>
                                {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}} of {{pagination.totalItems}} Variables
                            </clr-dg-pagination>
                        </clr-dg-footer>
                    </clr-datagrid>
                </div>
                <button class="btn btn-link " (click)="addVariable()">
                    <clr-icon shape="plus-circle "></clr-icon>
                    New Bacnet variable
                </button>
                <button *ngIf="selectedConnector" type="button" class="btn btn-link" [clrLoading]="savingRemovingVariable" (click)="removeVariable(); ">
                    <clr-icon shape="minus-circle "></clr-icon>
                    Remove variable
                </button>

                <form clrForm *ngIf="selectedVariable">
                    <clr-input-container>
                        <label>Variable ID </label>
                        <input clrInput type="text" [(ngModel)]="selectedVariable.Variable.xautovariableid" name="variablexautovariableid" disabled size="35" />
                    </clr-input-container>

                    <clr-input-container>
                        <label>Name </label>
                        <input clrInput type="text" [(ngModel)]="selectedVariable.Variable.name" name="variablename" size="35" />
                    </clr-input-container>

                    <clr-input-container>
                        <label>Description </label>
                        <input clrInput type="text" [(ngModel)]="selectedVariable.Variable.description" name="variabledescription" size="35" />
                    </clr-input-container>

                    <clr-input-container>
                        <label>XAuto Group </label>
                        <input clrInput type="text" [(ngModel)]="selectedVariable.Variable.xautogroup" name="variablexautogroup" size="35" />
                    </clr-input-container>

                    <clr-input-container>
                        <label>XGroup </label>
                        <input clrInput type="text" [(ngModel)]="selectedVariable.Variable.xgroup" name="variablexgroup" size="35" />
                    </clr-input-container>

                    <clr-toggle-container>
                        <clr-toggle-wrapper>
                            <input type="checkbox" clrToggle value="true" name="uselineratransform" [(ngModel)]="selectedVariable.Variable.transform.uselinetransform" />
                            <label>Use Line Transform</label>
                        </clr-toggle-wrapper>
                    </clr-toggle-container>

                    <clr-input-container *ngIf="selectedVariable.Variable.transform.uselinetransform">
                        <label>Line Transform K</label>
                        <input clrInput type="number" [(ngModel)]="selectedVariable.Variable.transform.linetransform_k" name="linetransk" size="35" />
                    </clr-input-container>
                    <clr-input-container *ngIf="selectedVariable.Variable.transform.uselinetransform">
                        <label>Line Transform M</label>
                        <input clrInput type="number" [(ngModel)]="selectedVariable.Variable.transform.linetransform_m" name="linetransm" size="35" />
                    </clr-input-container>       
                    
                    <clr-input-container>
                        <label>Default (init) value</label>
                        <input clrInput type="number" [(ngModel)]="selectedVariable.Variable.defaultvalue" name="defaultvalue" size="35" />
                    </clr-input-container>
                    <clr-toggle-container>
                        <clr-toggle-wrapper>
                            <input type="checkbox" clrToggle value="true" name="haslimits" [(ngModel)]="selectedVariable.Variable.haslimits" />
                            <label>Use Limits</label>
                        </clr-toggle-wrapper>
                    </clr-toggle-container>
                    <clr-input-container *ngIf="selectedVariable.Variable.haslimits">
                        <label>Min value</label>
                        <input clrInput type="number" [(ngModel)]="selectedVariable.Variable.minvalue" name="minvalue" size="35" />
                    </clr-input-container>
                    <clr-input-container *ngIf="selectedVariable.Variable.haslimits">
                        <label>Max value</label>
                        <input clrInput type="number" [(ngModel)]="selectedVariable.Variable.maxvalue" name="maxvalue" size="35" />
                    </clr-input-container>

                    <clr-toggle-container>
                        <clr-toggle-wrapper>
                            <input type="checkbox" clrToggle value="true" name="variablewritable" [(ngModel)]="selectedVariable.Variable.writable" enabled="false" />
                            <label>Writable</label>
                        </clr-toggle-wrapper>
                    </clr-toggle-container>


                    <clr-toggle-container>
                        <clr-toggle-wrapper>
                            <input type="checkbox" clrToggle value="true" name="defaultsample" [(ngModel)]="selectedVariable.Variable.usedefaultsampleintervalseconds" enabled="false" />
                            <label>Use default sample interval</label>
                        </clr-toggle-wrapper>
                    </clr-toggle-container>
                    

                    <clr-input-container *ngIf="!selectedVariable.Variable.usedefaultsampleintervalseconds">
                        <label>Sample interval (seconds) </label>
                        <input clrInput type="number" [(ngModel)]="selectedVariable.Variable.sampleintervalseconds" name="variablesampleinterval" size="35" />
                    </clr-input-container>

                    <clr-toggle-container>
                        <clr-toggle-wrapper>
                            <input type="checkbox" clrToggle value="true" name="dafaultflush" [(ngModel)]="selectedVariable.Variable.usedefaultflushintervalseconds" enabled="false" />
                            <label>Use default flush interval</label>
                        </clr-toggle-wrapper>
                    </clr-toggle-container>

                    <clr-input-container *ngIf="!selectedVariable.Variable.usedefaultflushintervalseconds">
                        <label>Flush interval (seconds) </label>
                        <input clrInput type="number" [(ngModel)]="selectedVariable.Variable.flushintervalseconds" name="variableflushinterval" size="35" />
                    </clr-input-container>


                    <clr-input-container>
                        <label>Device Instance (set to 0 for own object)</label>
                        <input clrInput type="number" [(ngModel)]="selectedVariable.Bacnet.deviceinstance" name="variabledeviceinstanceid" size="35" />
                    </clr-input-container>


                    <!-- Todo: Create a proper pipe for enums, see https://stackoverflow.com/questions/38554562/how-can-i-use-ngfor-to-iterate-over-typescript-enum-as-an-array-of-strings -->
                    <clr-select-container>
                        <label>Bacnet unit</label>
                        <select clrSelect name="varbacnetunits" [(ngModel)]="selectedVariable.Bacnet.units">
                            <option *ngFor="let item of XAUTO_BACNET_ENGINEERING_UNITS | keyvalue" 
                            [ngValue]="item.value">{{item.key.replace("UNITS_", "")}}</option>                            
                        </select>
                    </clr-select-container>


                    <clr-select-container>
                        <label>Bacnet object type</label>
                        <select clrSelect name="varbacnetobjtype" [(ngModel)]="selectedVariable.Bacnet.type">
                            <option *ngFor="let item of XAUTO_BACNET_OBJECT_TYPE_SUPPORTED | keyvalue" 
                            [ngValue]="item.value">{{item.key}}</option>                            
                        </select>
                    </clr-select-container>


                    <clr-input-container>
                        <label>Index</label>
                        <input clrInput type="number" [(ngModel)]="selectedVariable.Bacnet.index" name="variabledeviceindex" size="35" />
                    </clr-input-container>                    


                    <clr-toggle-container>
                        <clr-toggle-wrapper>
                            <input type="checkbox" clrToggle value="true" name="variableenabled" [(ngModel)]="selectedVariable.Variable.enabled" />
                            <label>Enabled</label>
                        </clr-toggle-wrapper>
                    </clr-toggle-container>

                    <button class="btn" [clrLoading]="savingVariable" (click)="saveVariable()">Save</button>

                </form> 

            </clr-accordion-content>
        </clr-accordion-panel>

        <clr-accordion-panel [clrAccordionPanelOpen]="false">
            <clr-accordion-title>Discovered</clr-accordion-title>
            <clr-accordion-content>
                <button class="btn" (click)="getDiscovered()">Get discovered</button><br>

                <div class="limit-height" style="max-width:1200px;">
                    <clr-datagrid class="datagrid-compact" [(clrDgSingleSelected)]="selectedDiscovered" [clrDgRowSelection]="true" [clrDgLoading]="loadingConnectors">

                        <clr-dg-column [clrDgField]="'xautogroup'"> XAutoGroup </clr-dg-column>
                        <clr-dg-column [clrDgField]="'xgroup'" [clrDgSortOrder]="ascSort"> XGroup </clr-dg-column>
                        <clr-dg-column [clrDgField]="'name'"> Name </clr-dg-column>
                        <clr-dg-column [clrDgField]="'type'"> Type </clr-dg-column>

                        <clr-dg-row *clrDgItems="let variable of selectedConnector.Discovered" [clrDgItem]="variable">
                            <clr-dg-cell class="cellhideoverflow"> {{variable.variable.xautogroup}} </clr-dg-cell>
                            <clr-dg-cell class="cellhideoverflow"> {{variable.variable.xgroup}} </clr-dg-cell>
                            <clr-dg-cell class="cellhideoverflow"> {{variable.variable.name}} </clr-dg-cell>

                            <clr-dg-cell class="cellhideoverflow">
                                <!-- todo this should not be padded in top if we use clrSelect as we want -->
                                <select  name="varbacnetobjtypedisc{variable.xautovariableid}" [(ngModel)]="variable.bacnet.type" disabled>
                                    <option *ngFor="let item of XAUTO_BACNET_OBJECT_TYPE | keyvalue" 
                                    [ngValue]="item.value">{{item.key}}</option>                            
                                </select>
                            </clr-dg-cell>

                        </clr-dg-row>

                        <clr-dg-footer>
                            <clr-dg-pagination #pagination2 [clrDgPageSize]="sizeOptions[1]">
                                <clr-dg-page-size [clrPageSizeOptions]="sizeOptions">Variables per page</clr-dg-page-size>
                                {{pagination2.firstItem + 1}} - {{pagination2.lastItem + 1}} of {{pagination2.totalItems}} Discovered
                            </clr-dg-pagination>
                        </clr-dg-footer>
                    </clr-datagrid>
                </div>
                
                <form clrForm *ngIf="selectedDiscovered">
                    <clr-input-container>
                        <label>Variable ID </label>
                        <input clrInput type="text" [(ngModel)]="selectedDiscovered.bacnet.xautovariableid" name="discvariablexautovariableiddisc" disabled size="35" />
                    </clr-input-container>

                    <clr-input-container>
                        <label>Name </label>
                        <input clrInput type="text" [(ngModel)]="selectedDiscovered.variable.name" name="variablenamedisc" size="35" />
                    </clr-input-container>

                    <clr-input-container>
                        <label>Description </label>
                        <input clrInput type="text" [(ngModel)]="selectedDiscovered.variable.description" name="variabledescriptiondisc" size="35" />
                    </clr-input-container>

                    <clr-input-container>
                        <label>XAuto Group </label>
                        <input clrInput type="text" [(ngModel)]="selectedDiscovered.variable.xautogroup" name="variablexautogroupdisc" size="35" />
                    </clr-input-container>

                    <clr-input-container>
                        <label>XGroup </label>
                        <input clrInput type="text" [(ngModel)]="selectedDiscovered.variable.xgroup" name="variablexgroupdisc" size="35" />
                    </clr-input-container>

                    <clr-toggle-container>
                        <clr-toggle-wrapper>
                            <input type="checkbox" clrToggle value="true" name="uselineratransformdisc" [(ngModel)]="selectedDiscovered.variable.transform.uselinetransform" />
                            <label>Use Line Transform</label>
                        </clr-toggle-wrapper>
                    </clr-toggle-container>

                    <clr-input-container *ngIf="selectedDiscovered.variable.transform.uselinetransform">
                        <label>Line Transform K</label>
                        <input clrInput type="number" [(ngModel)]="selectedDiscovered.variable.transform.linetransform_k" name="linetranskdisc" size="35" />
                    </clr-input-container>
                    <clr-input-container *ngIf="selectedDiscovered.variable.transform.uselinetransform">
                        <label>Line Transform M</label>
                        <input clrInput type="number" [(ngModel)]="selectedDiscovered.variable.transform.linetransform_m" name="linetransmdisc" size="35" />
                    </clr-input-container>                    

                    <clr-input-container>
                        <label>Default (init) value</label>
                        <input clrInput type="number" [(ngModel)]="selectedDiscovered.variable.defaultvalue" name="defaultvaluedesc" size="35" />
                    </clr-input-container>
                    <clr-toggle-container>
                        <clr-toggle-wrapper>
                            <input type="checkbox" clrToggle value="true" name="haslimitsdesc" [(ngModel)]="selectedDiscovered.variable.haslimits" />
                            <label>Use Limits</label>
                        </clr-toggle-wrapper>
                    </clr-toggle-container>
                    <clr-input-container *ngIf="selectedDiscovered.variable.haslimits">
                        <label>Min value</label>
                        <input clrInput type="number" [(ngModel)]="selectedDiscovered.variable.minvalue" name="descminvalue" size="35" />
                    </clr-input-container>
                    <clr-input-container *ngIf="selectedDiscovered.variable.haslimits">
                        <label>Max value</label>
                        <input clrInput type="number" [(ngModel)]="selectedDiscovered.variable.maxvalue" name="descmaxvalue" size="35" />
                    </clr-input-container>

                    <clr-toggle-container>
                        <clr-toggle-wrapper>
                            <input type="checkbox" clrToggle value="true" name="variablewritabledisc" [(ngModel)]="selectedDiscovered.variable.writable" enabled="false" />
                            <label>Writable</label>
                        </clr-toggle-wrapper>
                    </clr-toggle-container>


                    <clr-toggle-container>
                        <clr-toggle-wrapper>
                            <input type="checkbox" clrToggle value="true" name="defaultsampledisc" [(ngModel)]="selectedDiscovered.variable.usedefaultsampleintervalseconds" enabled="false" />
                            <label>Use default sample interval</label>
                        </clr-toggle-wrapper>
                    </clr-toggle-container>
                    

                    <clr-input-container *ngIf="!selectedDiscovered.variable.usedefaultsampleintervalseconds">
                        <label>Sample interval (seconds) </label>
                        <input clrInput type="number" [(ngModel)]="selectedDiscovered.variable.sampleintervalseconds" name="variablesampleintervaldisc" size="35" />
                    </clr-input-container>

                    <clr-toggle-container>
                        <clr-toggle-wrapper>
                            <input type="checkbox" clrToggle value="true" name="dafaultflushdisc" [(ngModel)]="selectedDiscovered.variable.usedefaultflushintervalseconds" enabled="false" />
                            <label>Use default flush interval</label>
                        </clr-toggle-wrapper>
                    </clr-toggle-container>

                    <clr-input-container *ngIf="!selectedDiscovered.variable.usedefaultflushintervalseconds">
                        <label>Flush interval (seconds) </label>
                        <input clrInput type="number" [(ngModel)]="selectedDiscovered.variable.flushintervalseconds" name="variableflushintervaldisc" size="35" />
                    </clr-input-container>

                    <clr-input-container>
                        <label>Device Instance (set to 0 for own object)</label>
                        <input clrInput type="number" [(ngModel)]="selectedDiscovered.bacnet.deviceinstance" name="variabledeviceinstanceiddisc" size="35" />
                    </clr-input-container>


                    <!-- Todo: Create a proper pipe for enums, see https://stackoverflow.com/questions/38554562/how-can-i-use-ngfor-to-iterate-over-typescript-enum-as-an-array-of-strings -->
                    <clr-select-container>
                        <label>Bacnet unit</label>
                        <select clrSelect name="varbacnetunitsdisc" [(ngModel)]="selectedDiscovered.bacnet.units">
                            <option *ngFor="let item of XAUTO_BACNET_ENGINEERING_UNITS | keyvalue" 
                            [ngValue]="item.value">{{item.key.replace("UNITS_", "")}}</option>                            
                        </select>
                    </clr-select-container>


                    <clr-select-container>
                        <label>Bacnet object type</label>
                        <select clrSelect name="varbacnetobjtypedisc" [(ngModel)]="selectedDiscovered.bacnet.type">
                            <option *ngFor="let item of XAUTO_BACNET_OBJECT_TYPE_SUPPORTED | keyvalue" 
                            [ngValue]="item.value">{{item.key}}</option>                            
                        </select>
                    </clr-select-container>


                    <clr-input-container>
                        <label>Index</label>
                        <input clrInput type="number" [(ngModel)]="selectedDiscovered.bacnet.index" name="variabledeviceindexdisc" size="35" />
                    </clr-input-container>                    


                    <clr-toggle-container>
                        <clr-toggle-wrapper>
                            <input type="checkbox" clrToggle value="true" name="variableenableddisc" [(ngModel)]="selectedDiscovered.variable.enabled" />
                            <label>Enabled</label>
                        </clr-toggle-wrapper>
                    </clr-toggle-container> 

                    <button class="btn" [clrLoading]="savingVariable" (click)="saveVariableDisc()">Save</button>

                </form> 

            </clr-accordion-content>
        </clr-accordion-panel>        
    </clr-accordion>



</main>